import BossModeStats from './BossModeStats.page';

export default BossModeStats;
